<template>
	<view class="wallet-page">
		<view class="nav-bar" :style="{ paddingTop: statusbarHeight + 'px' }">
			<view class="nav-content">
				<text class="nav-title">门店钱包</text>
			</view>
		</view>
		<view class="page-content">
			<text>钱包页面</text>
		</view>
		<custom-tabbar></custom-tabbar>
	</view>
</template>

<script>
	import { mapState } from 'vuex'
	import CustomTabbar from '@/components/custom-tabbar/custom-tabbar.vue'

	export default {
		components: {
			CustomTabbar
		},
		computed: {
			...mapState(['statusbarHeight'])
		}
	}
</script>

<style lang="scss" scoped>
	.wallet-page {
		min-height: 100vh;
		background: #f8f8f8;
	}

	.nav-bar {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		background: #ffffff;
		z-index: 100;
	}

	.nav-content {
		height: 44px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.nav-title {
		font-size: 34rpx;
		font-weight: 600;
		color: #333333;
	}

	.page-content {
		padding-top: calc(44px + 44px);
	}
</style>
